export const useSort = () => {

  const sortDropHelper = (dropResult, list): any[] => {
    if (!dropResult) return list
    const { removedIndex, addedIndex, payload } = dropResult
    if (removedIndex === null && addedIndex === null) return
    const result = [...list]
    let itemToAdd = payload
    if (removedIndex !== null) {
      itemToAdd = result.splice(removedIndex, 1)[0]
    }
    if (addedIndex !== null) {
      result.splice(addedIndex, 0, itemToAdd)
    }
    return result
  }

  const onDropSort = (dropResult, list) => {
    return sortDropHelper(dropResult, list)
  }

  return {
    onDropSort
  }

}
